import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import {Routes} from "../constants";

const ProtectedRoute = ({ component: Component, authenticated, ...rest}) => {
    return <Route render={(props) => (authenticated ? <Component {...props} /> : authenticated === null ? <div>Waiting for login info</div> : <Redirect to={Routes.signin} />)} {...rest} />;
};
export default ProtectedRoute;